import { createCrudPage } from './factories/crud-page.js';

export default createCrudPage({
  title: 'Forum',
  basePath: '/forum',
  columns: [
    { key: 'forum_date', label: 'Date', sortable: true },
    { key: 'forum_name', label: 'Name', sortable: true },
    { key: 'forum_email', label: 'Email', sortable: true },
    { key: 'forum_text', label: 'Text', sortable: true },
    { key: 'forumtemat_name', label: 'Theme', sortable: true },
  ],
  fields: [
    { key: 'forum_name', label: 'Name', type: 'text', required: true },
    { key: 'forum_email', label: 'Email', type: 'text' },
    { key: 'forum_text', label: 'Text', type: 'textarea' },
    { key: 'forum_date', label: 'Date', type: 'datetime' },
  ],
  defaultSort: { field: 'forum_date', dir: 'desc' },
});
